import React, { createContext, useContext, useState, useEffect } from 'react';
const CompareContext = createContext(null);
const load = () => { try { return JSON.parse(localStorage.getItem('dz_compare') || '[]'); } catch { return []; } };
export const CompareProvider = ({ children }) => {
  const [ids, setIds] = useState(load);
  useEffect(() => {
    const refresh = () => setIds(load());
    window.addEventListener('compare-changed', refresh);
    window.addEventListener('storage', refresh);
    return () => { window.removeEventListener('compare-changed', refresh); window.removeEventListener('storage', refresh); };
  }, []);
  const isInCompare = (id) => ids.includes(id);
  const toggleCompare = (product) => {
    let next;
    if (ids.includes(product.id)) { next = ids.filter(x => x !== product.id); }
    else { if (ids.length >= 4) return false; next = [...ids, product.id]; }
    localStorage.setItem('dz_compare', JSON.stringify(next));
    setIds(next);
    window.dispatchEvent(new Event('compare-changed'));
    return true;
  };
  const clearCompare = () => { localStorage.setItem('dz_compare', '[]'); setIds([]); window.dispatchEvent(new Event('compare-changed')); };
  return <CompareContext.Provider value={{ ids, isInCompare, toggleCompare, clearCompare }}>{children}</CompareContext.Provider>;
};
export const useCompare = () => { const ctx = useContext(CompareContext); if (!ctx) throw new Error('useCompare must be inside CompareProvider'); return ctx; };
